

class CoOrdsSelector {
    constructor() {
      this.selectedTop = null;
      this.selectedBottom = null;
      this.currentStep = 0; // Start with color selection step
      this.totalSteps = 4; // Now we have 4 steps: 0=color, 1=top, 2=bottom, 3=review
      this.currentProduct = null;
      this.selectedVariant = null;
  
      this.sectionRoot = document.querySelector('.co-ords-selector[data-section-id]');
      this.discountPercent = this.getDiscountPercent();
      this.discountCode = this.getDiscountCode();
  
      this.sizeChartModal = document.getElementById('size-chart-modal');
      this.sizeChartImage = document.getElementById('size-chart-image');
      this.viewSizeChartBtn = document.getElementById('view-size-chart-btn');
      this.closeSizeChartBtn = document.getElementById('close-size-chart-btn');
  
      this.preferredColor=null;
      
      this.init();
    }
  
    init() {
      this.bindEvents();
      this.updateNavigation();
      this.initSizePopup();
      this.initSizeChartModal();
      this.initFilters();
      this.initGlobalClickHandler();
      this.initColorGate();
      
      // Initialize filters for both steps
      setTimeout(() => {
        this.initStepFilters('tops');
        this.initStepFilters('bottoms');
        console.log('Initialized filters for both steps');
      }, 500);

      // Set flush-bottom class on initial load if banner exists (step 0 is default)
      if (this.sectionRoot && document.querySelector('.color-step-banner')) {
        this.sectionRoot.classList.add('color-step-active');
      }
    }
  
    initGlobalClickHandler() {
      // Close dropdown when clicking outside
      document.addEventListener('click', (e) => {
        if (!e.target.closest('.filter-dropdown')) {
          document.querySelectorAll('.filter-options.show').forEach(opt => {
            opt.classList.remove('show');
            opt.style.display = 'none';
          });
          document.querySelectorAll('.filter-button.active').forEach(btn => {
            btn.classList.remove('active');
          });
        }
      });
    }
  
  
    bindEvents() {
      
      document.addEventListener('click', (e) => {
        // Handle thumbnail clicks first and stop bubbling so card click doesn't fire
        const thumb = e.target.closest('.thumbnail');
        if (thumb) {
          this.handleThumbnailClick(thumb);
          e.stopPropagation();
          return;
        }
  
        // Make the entire product card clickable (except thumbnails handled above)
        const clickedCard = e.target.closest('.product-card');
        if (clickedCard) {
          this.handleProductSelectionFromCard(clickedCard);
          e.stopPropagation();
          return;
        }
  
        // Fallback: if button still exists somewhere, handle it
        if (e.target.classList.contains('select-product-btn')) {
          this.handleProductSelection(e.target);
        }
        
        if (e.target.classList.contains('next-btn')) {
          this.nextStep();
        }
        
        if (e.target.classList.contains('prev-btn')) {
          this.previousStep();
        }
        
        if (e.target.id === 'add-to-cart-btn') {
          this.addToCartAndCheckout();
        }
  
        // (thumbnail handled at the top)
  
      });
    }
  
    handleThumbnailClick(thumbnail) {
      const productCard = thumbnail.closest('.product-card');
      const mainImage = productCard.querySelector('.main-image');
      const allThumbnails = productCard.querySelectorAll('.thumbnail');
      
      // Remove active class from all thumbnails
      allThumbnails.forEach(thumb => thumb.classList.remove('active'));
      
      // Add active class to clicked thumbnail
      thumbnail.classList.add('active');
      
      // Update main image
      const newMainSrc = thumbnail.dataset.mainSrc;
      if (newMainSrc) {
        mainImage.src = newMainSrc;
      }
    }
  
    initSizePopup() {
      
      document.getElementById('size-popup').addEventListener('click', (e) => {
        if (e.target.id === 'size-popup') {
          this.closeSizePopup();
        }
      });
  
     
      document.getElementById('close-popup-btn').addEventListener('click', () => {
        this.closeSizePopup();
      });
  
      // Confirm button
      document.getElementById('confirm-size-btn').addEventListener('click', () => {
        this.confirmSizeSelection();
      });
    }
  
    handleProductSelectionFromCard(productCard) {
      const productId = productCard.dataset.productId;
      const productType = productCard.dataset.productType;
      const productHandle = productCard.dataset.productHandle;
      const productPrice = parseFloat(productCard.dataset.productPrice);
      const productTitle = productCard.querySelector('.product-title').textContent;
      const productImage = productCard.querySelector('.product-image img').src;
  
      const sizeChartUrl = productCard.dataset.sizeChartUrl || '';
  
      // Store current product - convert price from cents to actual price
      const actualPrice = productPrice / 100; // Convert from cents to actual price
      console.log('Product Price Conversion:', { raw: productPrice, converted: actualPrice });
      
      this.currentProduct = {
        id: productId,
        handle: productHandle,
        price: actualPrice,
        title: productTitle,
        image: productImage,
        type: productType,
        sizeChartUrl: sizeChartUrl
      };
  
      // Fetch product variants and show size popup
      this.fetchProductVariants(productHandle);
    }
  
    handleProductSelection(button) {
      const productCard = button.closest('.product-card');
      const productId = button.dataset.productId;
      const productType = button.dataset.productType;
      const productHandle = productCard.dataset.productHandle;
      const productPrice = parseFloat(productCard.dataset.productPrice);
      const productTitle = productCard.querySelector('.product-title').textContent;
      const productImage = productCard.querySelector('.product-image img').src;
  
      const sizeChartUrl = productCard.dataset.sizeChartUrl || '';
  
      // Store current product - convert price from cents to actual price
      const actualPrice = productPrice / 100; // Convert from cents to actual price
      console.log('Product Price Conversion:', { raw: productPrice, converted: actualPrice });
      
      this.currentProduct = {
        id: productId,
        handle: productHandle,
        price: actualPrice,
        title: productTitle,
        image: productImage,
        type: productType,
        sizeChartUrl: sizeChartUrl
      };
  
      // Fetch product variants and show size popup
      this.fetchProductVariants(productHandle);
    }
  
    async fetchProductVariants(productHandle) {
      try {
        // Fetch product data from Shopify
        const response = await fetch(`/products/${productHandle}.js`);
        const product = await response.json();
        
        // Store variants and images for size selection
        this.currentProduct.variants = product.variants;
        this.currentProduct.images = product.images;
        
        // Show size selection popup
        this.showSizePopup();
      } catch (error) {
        console.error('Error fetching product variants:', error);
        // Fallback: show popup without variants
        this.showSizePopup();
      }
    }
  
    showSizePopup() {
      const popup = document.getElementById('size-popup');
      const title = document.getElementById('size-popup-title');
      const image = document.getElementById('size-popup-image');
      const productTitle = document.getElementById('size-popup-product-title');
      const price = document.getElementById('size-popup-price');
      const sizeButtons = document.getElementById('size-buttons');
      const popupThumbnails = document.getElementById('popup-thumbnails');
  
      // Update popup content
      title.textContent = `Select Size for ${this.currentProduct.title}`;
      image.src = this.currentProduct.image;
      image.alt = this.currentProduct.title;
      productTitle.textContent = this.currentProduct.title;
      price.textContent = `INR ${this.currentProduct.price.toFixed(2)}`;
  
      // Populate popup image gallery
      this.populatePopupImageGallery(popupThumbnails);
  
      if(this.currentProduct.sizeChartUrl){
        console.log('size chart url',this.currentProduct.sizeChartUrl);
        this.viewSizeChartBtn.style.display = 'inline-block';
      }else{
        console.log('no size chart url');
        this.viewSizeChartBtn.style.display = 'none';
      }
  
      // Populate size buttons with real variants
      this.populateSizeButtons(sizeButtons);
  
      // Reset selection
      this.selectedVariant = null;
      this.updateConfirmButton();
  
      // Show popup
      popup.style.display = 'flex';
    }
  
    populatePopupImageGallery(container) {
      container.innerHTML = ''; // Clear existing thumbnails
      
      if (this.currentProduct.images && this.currentProduct.images.length > 1) {
        // Show thumbnails for all images except the first one (which is already shown as main)
        for (let i = 1; i < this.currentProduct.images.length && i < 5; i++) {
          const image = this.currentProduct.images[i];
          const thumbnail = document.createElement('img');
          thumbnail.src = image.src || image;
          thumbnail.alt = `${this.currentProduct.title} - Image ${i + 1}`;
          thumbnail.className = 'popup-thumbnail';
          thumbnail.width = 40;
          thumbnail.height = 40;
          
          // Add click event to change main image
          thumbnail.addEventListener('click', () => {
            const mainImage = document.getElementById('size-popup-image');
            const thumbnailSrc = thumbnail.src;
            // Directly set the main image source without swapping
            mainImage.src = thumbnailSrc;
            
            // Update active state for popup thumbnails
            const allPopupThumbnails = container.querySelectorAll('.popup-thumbnail');
            allPopupThumbnails.forEach(thumb => thumb.classList.remove('active'));
            thumbnail.classList.add('active');
          });
          
          container.appendChild(thumbnail);
        }
      } else {
        // Hide the thumbnails container if there's only one image
        container.style.display = 'none';
      }
    }
  
    populateSizeButtons(container) {
      container.innerHTML = ''; // Clear existing buttons
      
      const sizePatterns = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', '3XL', '4XL', '5XL'];
      const sizeMap = new Map();
  
      if (this.currentProduct.variants && this.currentProduct.variants.length > 0) {
        this.currentProduct.variants.forEach(variant => {
          const size = this.extractSizeFromVariant(variant, sizePatterns);
          if (!size) return;
  
          const price = variant.price / 100; // convert cents to currency
          const entry = sizeMap.get(size) || { size, available: false, variantId: null, price };
  
          if (variant.available) {
            entry.available = true;
            entry.variantId = variant.id;
            entry.price = price;
          } else if (!entry.variantId) {
            // keep first unavailable variant id as fallback (could be null)
            entry.variantId = variant.id;
            entry.price = price;
          }
  
          sizeMap.set(size, entry);
        });
      }
  
      if (sizeMap.size > 0) {
        sizeMap.forEach(entry => {
          const sizeBtn = document.createElement('button');
          sizeBtn.className = 'size-btn';
          sizeBtn.dataset.size = entry.size;
          sizeBtn.dataset.price = entry.price;
  
          if (entry.available && entry.variantId) {
            sizeBtn.dataset.variantId = entry.variantId;
          } else {
            sizeBtn.disabled = true;
            sizeBtn.classList.add('disabled');
          }
  
          sizeBtn.textContent = entry.size;
  
          sizeBtn.addEventListener('click', (e) => {
            this.selectVariant(e.target);
          });
  
          container.appendChild(sizeBtn);
        });
      } else {
        // Fallback: show generic sizes
        this.showGenericSizes(container);
      }
    }
  
    extractSizeFromVariant(variant, sizePatterns) {
      const options = [variant.option1, variant.option2, variant.option3].filter(Boolean);
      for (const option of options) {
        const upper = option.toUpperCase();
        if (sizePatterns.some(pattern => upper.includes(pattern))) {
          return option;
        }
      }
      return null;
    }
    
    showGenericSizes(container) {
      const genericSizes = ['S', 'M', 'L', 'XL'];
      genericSizes.forEach(size => {
        const sizeBtn = document.createElement('button');
        sizeBtn.className = 'size-btn';
        sizeBtn.dataset.size = size;
        sizeBtn.dataset.price = this.currentProduct.price; // Use the already-converted price
        sizeBtn.textContent = size;
        
        sizeBtn.addEventListener('click', (e) => {
          this.selectVariant(e.target);
        });
        
        container.appendChild(sizeBtn);
      });
    }
  
    selectVariant(variantButton) {
      if (variantButton.disabled || variantButton.classList.contains('disabled')) {
        return;
      }
      
      // Remove previous selection
      document.querySelectorAll('.size-btn').forEach(btn => {
        btn.classList.remove('selected');
      });
  
      // Select new variant
      variantButton.classList.add('selected');
      
      // Store selected variant info
      this.selectedVariant = {
        id: variantButton.dataset.variantId,
        size: variantButton.dataset.size,
        price: parseFloat(variantButton.dataset.price) || this.currentProduct.price
      };
  
      // Enable confirm button
      this.updateConfirmButton();
    }
  
    updateConfirmButton() {
      const confirmBtn = document.getElementById('confirm-size-btn');
      if (this.selectedVariant) {
        confirmBtn.disabled = false;
        confirmBtn.textContent = `Confirm Size ${this.selectedVariant.size}`;
      } else {
        confirmBtn.disabled = true;
        confirmBtn.textContent = 'Confirm Selection';
      }
    }
  
    confirmSizeSelection() {
      if (!this.currentProduct || !this.selectedVariant) {
        return;
      }
  
      // Create product with variant info
      const productWithVariant = {
        ...this.currentProduct,
        variantId: this.selectedVariant.id,
        size: this.selectedVariant.size,
        price: this.selectedVariant.price
      };
  
      // Store based on type
      if (this.currentProduct.type === 'top') {
        this.selectedTop = productWithVariant;
        this.updateSelectedTopUI();
      } else if (this.currentProduct.type === 'bottom') {
        this.selectedBottom = productWithVariant;
        this.updateSelectedBottomUI();
      }
  
      // Close popup
      this.closeSizePopup();
  
      // Move to next step
      setTimeout(() => {
        this.nextStep();
      }, 500);
    }
  
    closeSizePopup() {
      document.getElementById('size-popup').style.display = 'none';
      this.currentProduct = null;
      this.selectedVariant = null;
    }
  
    updateSelectedTopUI() {
      const summaryElement = document.getElementById('selected-top-summary');
      if (summaryElement && this.selectedTop) {
        summaryElement.innerHTML = `
          <div class="selected-product-display">
            <img src="${this.selectedTop.image}" alt="${this.selectedTop.title}" width="100" height="100">
            <div class="product-details">
              <h4>${this.selectedTop.title}</h4>
              <p class="size">Size: ${this.selectedTop.size}</p>
              <p class="price">INR ${this.selectedTop.price.toFixed(2)}</p>
            </div>
          </div>
        `;
      }
    }
  
    updateSelectedBottomUI() {
      const summaryElement = document.getElementById('final-top-summary');
      const bottomSummaryElement = document.getElementById('final-bottom-summary');
      
      // Determine where the flat discount applies:
      // - Default: discount on BOTTOM
      // - For Sand & Sage: discount on TOP instead
      const discountOnTop = this.preferredColor === 'Sand' || this.preferredColor === 'Sage';
      const flatDiscount = 1000;
  
      if (summaryElement && this.selectedTop) {
        const topOriginalPrice = this.selectedTop.price;
        const topDiscountAmount = discountOnTop ? Math.min(flatDiscount, topOriginalPrice) : 0;
        const topFinalPrice = Math.max(0, topOriginalPrice - topDiscountAmount);
  
        // If discount applies to top, show strike-through + discounted price
        const topPriceHtml = topDiscountAmount > 0
          ? `
              <p class="price">
                <span style="text-decoration: line-through; color: #999; margin-right: 8px;">INR ${topOriginalPrice.toFixed(2)}</span>
                <span style="color: #4CAF50; font-weight: bold;">INR ${topFinalPrice.toFixed(2)}</span>
                <span style="color: #4CAF50; font-size: 0.9em; margin-left: 8px;">(₹${topDiscountAmount.toFixed(2)} off)</span>
              </p>
            `
          : `<p class="price">INR ${topOriginalPrice.toFixed(2)}</p>`;
  
        summaryElement.innerHTML = `
          <div class="selected-product-display">
            <img src="${this.selectedTop.image}" alt="${this.selectedTop.title}" width="100" height="100">
            <div class="product-details">
              <h4>${this.selectedTop.title}</h4>
              <p class="size">Size: ${this.selectedTop.size}</p>
              ${topPriceHtml}
            </div>
          </div>
        `;
      }
      
      if (bottomSummaryElement && this.selectedBottom) {
        const bottomOriginalPrice = this.selectedBottom.price;
        const bottomDiscountAmount = !discountOnTop ? Math.min(flatDiscount, bottomOriginalPrice) : 0;
        const bottomFinalPrice = Math.max(0, bottomOriginalPrice - bottomDiscountAmount);
  
        // If discount applies to bottom, show strike-through + discounted price, otherwise normal price
        const bottomPriceHtml = bottomDiscountAmount > 0
          ? `
              <p class="price">
                <span style="text-decoration: line-through; color: #999; margin-right: 8px;">INR ${bottomOriginalPrice.toFixed(2)}</span>
                <span style="color: #4d4d4d; font-weight: bold;">INR ${bottomFinalPrice.toFixed(2)}</span>
                <span style="color: #4CAF50; font-size: 0.9em;">(₹${bottomDiscountAmount.toFixed(2)} off)</span>
              </p>
            `
          : `<p class="price">INR ${bottomOriginalPrice.toFixed(2)}</p>`;
        
        bottomSummaryElement.innerHTML = `
          <div class="selected-product-display">
            <img src="${this.selectedBottom.image}" alt="${this.selectedBottom.title}" width="100" height="100">
            <div class="product-details">
              <h4>${this.selectedBottom.title}</h4>
              <p class="size">Size: ${this.selectedBottom.size}</p>
              ${bottomPriceHtml}
            </div>
          </div>
        `;
      }
      
      // Update total price
      this.updateTotalPrice();
    }
  
    updateTotalPrice() {
      if (this.selectedTop && this.selectedBottom) {
        // Apply flat ₹1000 off on one item:
        // - Default: BOTTOM
        // - For Sand & Sage: TOP
        const discountOnTop = this.preferredColor === 'Sand' || this.preferredColor === 'Sage';
        const flatDiscount = 1000;
  
        const topOriginalPrice = this.selectedTop.price;
        const bottomOriginalPrice = this.selectedBottom.price;
  
        const topDiscountAmount = discountOnTop ? Math.min(flatDiscount, topOriginalPrice) : 0;
        const bottomDiscountAmount = !discountOnTop ? Math.min(flatDiscount, bottomOriginalPrice) : 0;
  
        const topFinalPrice = Math.max(0, topOriginalPrice - topDiscountAmount);
        const bottomFinalPrice = Math.max(0, bottomOriginalPrice - bottomDiscountAmount);
        
        const originalTotal = topOriginalPrice + bottomOriginalPrice;
        const finalPrice = topFinalPrice + bottomFinalPrice;
        const totalDiscountAmount = topDiscountAmount + bottomDiscountAmount;
        
        // Update original price (crossed out)
        const originalPriceElement = document.getElementById('original-price');
        if (originalPriceElement) {
          originalPriceElement.textContent = `INR ${originalTotal.toFixed(2)}`;
        }
        
        // Update final discounted price
        const totalPriceElement = document.getElementById('total-price');
        if (totalPriceElement) {
          totalPriceElement.textContent = `INR ${finalPrice.toFixed(2)}`;
        }
  
        const discountInfoElement = document.getElementById('discount-info-text');
        if (discountInfoElement) {
          // Get color-specific discount code
          // const discountCode = this.getColorSpecificDiscountCode();
          // const codeFragment = discountCode 
          //   ? ` &mdash; Code <strong>${discountCode.toUpperCase()}</strong> auto-applied at cart`
          //   : '';
          // const targetLabel = discountOnTop ? 'Top' : 'Bottom';
          // discountInfoElement.innerHTML = `₹${totalDiscountAmount.toFixed(2)} Off Applied on ${targetLabel}${codeFragment}!`;
  
  
          discountInfoElement.innerHTML = 'A little thank you for curating your own look.<br>₹1000/- off on your signature piece.'
        }
        
        // Update copy discount button if it exists
        this.updateCopyDiscountButton();
        
        console.log(`Price breakdown: Color: ${this.preferredColor || 'N/A'}, Top Original: INR ${topOriginalPrice.toFixed(2)}, Top Discount: INR ${topDiscountAmount.toFixed(2)}, Top Final: INR ${topFinalPrice.toFixed(2)}, Bottom Original: INR ${bottomOriginalPrice.toFixed(2)}, Bottom Discount: INR ${bottomDiscountAmount.toFixed(2)}, Bottom Final: INR ${bottomFinalPrice.toFixed(2)}, Total Original: INR ${originalTotal.toFixed(2)}, Total Final: INR ${finalPrice.toFixed(2)}`);
      }
    }
  
    updateCopyDiscountButton() {
      const discountCode = this.getColorSpecificDiscountCode();
      if (!discountCode) return;
  
      let copyButton = document.getElementById('copy-discount-btn');
      if (!copyButton) {
        // Create copy button if it doesn't exist
        copyButton = document.createElement('button');
        copyButton.id = 'copy-discount-btn';
        copyButton.className = 'copy-discount-btn';
        copyButton.innerHTML = '📋 Copy Discount Code';
        
        // Insert before add to cart button
        const addToCartBtn = document.getElementById('add-to-cart-btn');
        if (addToCartBtn && addToCartBtn.parentNode) {
          addToCartBtn.parentNode.insertBefore(copyButton, addToCartBtn);
        }
        
        // Add click handler - get discount code dynamically
        copyButton.addEventListener('click', () => {
          const currentDiscountCode = this.getColorSpecificDiscountCode();
          if (currentDiscountCode) {
            this.copyDiscountCodeToClipboard(currentDiscountCode);
          }
        });
      }
      
      // Update button text with discount code
      copyButton.innerHTML = `Use discount code: <strong>${discountCode.toUpperCase()}</strong><span>&nbsp;<br/>(if not automatically applied at checkout)</span>`;
      copyButton.setAttribute('data-discount-code', discountCode);
    }
  
    async copyDiscountCodeToClipboard(discountCode) {
      try {
        await navigator.clipboard.writeText(discountCode);
        
        // Show success feedback
        const copyButton = document.getElementById('copy-discount-btn');
        if (copyButton) {
          const originalText = copyButton.innerHTML;
          copyButton.innerHTML = 'Copied!';
          copyButton.style.backgroundColor = 'none';
          copyButton.style.color = '#fff';
          
          
          setTimeout(() => {
            copyButton.innerHTML = originalText;
            copyButton.style.backgroundColor = '';
            copyButton.style.color = '';
          }, 2000);
        }
        
        // Also show a toast notification
        this.showSuccessMessage(`Discount code "${discountCode}" copied to clipboard!`);
      } catch (err) {
        console.error('Failed to copy discount code:', err);
        // Fallback for older browsers
        const textArea = document.createElement('textarea');
        textArea.value = discountCode;
        textArea.style.position = 'fixed';
        textArea.style.opacity = '0';
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand('copy');
          this.showSuccessMessage(`Discount code "${discountCode}" copied to clipboard!`);
        } catch (fallbackErr) {
          this.showError('Failed to copy discount code. Please copy manually: ' + discountCode);
        }
        document.body.removeChild(textArea);
      }
    }
  
    showSuccessMessage(message) {
      const successDiv = document.createElement('div');
      successDiv.className = 'co-ords-success';
      successDiv.textContent = message;
      successDiv.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: #4CAF50;
        color: white;
        padding: 15px 20px;
        border-radius: 5px;
        z-index: 1000;
        max-width: 300px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        animation: slideIn 0.3s ease-out;
      `;
  
      document.body.appendChild(successDiv);
  
      setTimeout(() => {
        if (successDiv.parentNode) {
          successDiv.style.animation = 'slideOut 0.3s ease-out';
          setTimeout(() => {
            if (successDiv.parentNode) {
              successDiv.parentNode.removeChild(successDiv);
            }
          }, 300);
        }
      }, 3000);
    }
  
    nextStep() {
      if (this.currentStep < this.totalSteps - 1) {
        // Validate current step
        if (this.currentStep === 1 && !this.selectedTop) {
          this.showError('Please select a top before proceeding.');
          return;
        }
        
        if (this.currentStep === 2 && !this.selectedBottom) {
          this.showError('Please select a bottom before proceeding.');
          return;
        }
        
        this.currentStep++;
        this.showStep(this.currentStep);
        this.updateNavigation();
      }
    }
  
    previousStep() {
      if (this.currentStep > 0) {
        this.currentStep--;
        this.showStep(this.currentStep);
        this.updateNavigation();
      }
    }
  
    showStep(stepNumber) {
      // Hide all steps
      const steps = document.querySelectorAll('.co-ords-step');
      steps.forEach(step => {
        step.style.display = 'none';
      });
      
      // Show current step
      const currentStepElement = document.getElementById(`step-${this.getStepName(stepNumber)}`);
      if (currentStepElement) {
        currentStepElement.style.display = 'block';
      }

      // Toggle flush-bottom class only on color step (step 0) when banner exists
      if (this.sectionRoot) {
        const hasBanner = !!document.querySelector('.color-step-banner');
        if (stepNumber === 0 && hasBanner) {
          this.sectionRoot.classList.add('color-step-active');
        } else {
          this.sectionRoot.classList.remove('color-step-active');
        }
      }
  
      // If showing review step, ensure copy button is created
      if (stepNumber === 3 && this.selectedTop && this.selectedBottom) {
        setTimeout(() => {
          this.updateCopyDiscountButton();
        }, 100);
      }
  
      // Reset all filters for the current step
      this.resetFiltersForStep(this.getStepName(stepNumber));
  
      // Re-initialize filters for the current step after a short delay
      setTimeout(() => {
        this.initStepFilters(this.getStepName(stepNumber));
        if (this.preferredColor) {
          const pluralStep = this.getStepName(stepNumber) === 'top' ? 'tops' : this.getStepName(stepNumber) === 'bottom' ? 'bottoms' : '';
          if (pluralStep) {
            console.log(`Re-applying preferred color ${this.preferredColor} to ${pluralStep}`);
            this.setFilterSelection(pluralStep, `color-${pluralStep}`, this.preferredColor);
            this.filterProducts(pluralStep);
          }
        }
        console.log(`Re-initialized filters for step: ${this.getStepName(stepNumber)}`);
      }, 100);
  
      // Scroll to the current step container so the banner is not shown again
      this.scrollToStep(stepNumber);
    }
  
    scrollToElement(element){
      if (!element) return;
      const rect = element.getBoundingClientRect();
      const offset = this.getStickyHeaderOffset();
      const y = Math.max(0, rect.top + window.pageYOffset - offset);
      this.smoothScrollTo(y, 600);
    }
  
    scrollToFlow(){
      const flow = document.querySelector('.co-ords-flow');
      if (!flow) return;
      this.scrollToElement(flow);
    }
  
    scrollToStep(stepNumber){
      const target = document.getElementById(`step-${this.getStepName(stepNumber)}`) || document.querySelector('.co-ords-flow');
      if (!target) return;
      // Scroll now
      this.scrollToElement(target);
      // And again shortly after to correct for late image/layout shifts
      setTimeout(() => this.scrollToElement(target), 250);
    }
  
    getStickyHeaderOffset(){
      // Try to account for common sticky header elements in Shopify themes
      const header = document.querySelector('header[role="banner"], .header, .site-header, .shopify-section-header-sticky, .shopify-section-header');
      const headerHeight = header ? header.offsetHeight : 0;
      return headerHeight + 12; // add small gap
    }
  
    smoothScrollTo(targetY, duration = 500) {
      const startY = window.pageYOffset;
      const distance = targetY - startY;
      if (Math.abs(distance) < 1) return;
  
      const startTime = performance.now();
  
      const easeInOutCubic = (t) => t < 0.5
        ? 4 * t * t * t
        : 1 - Math.pow(-2 * t + 2, 3) / 2;
  
      const step = (now) => {
        const elapsed = now - startTime;
        const progress = Math.min(1, elapsed / duration);
        const eased = easeInOutCubic(progress);
        window.scrollTo(0, startY + distance * eased);
        if (progress < 1) requestAnimationFrame(step);
      };
  
      requestAnimationFrame(step);
    }
  
    
  
    getStepName(stepNumber) {
      switch(stepNumber) {
        case 0: return 'color';
        case 1: return 'top';
        case 2: return 'bottom';
        case 3: return 'review';
        default: return 'color';
      }
    }
  
    resetFiltersForStep(step) {
      console.log(`Resetting filters for step: ${step}`);
      
      // Find all dropdowns in the current step
      const stepElement = document.getElementById(`step-${step}`);
      if (!stepElement) return;
      
      const dropdowns = stepElement.querySelectorAll('.filter-dropdown');
      
      dropdowns.forEach(dropdown => {
        const isMultiSelect = dropdown.classList.contains('multi-select');
        const options = dropdown.querySelector('.filter-options');
        
        // Reset all options to unselected
        const allOptions = dropdown.querySelectorAll('.filter-option');
        allOptions.forEach(option => {
          option.classList.remove('selected');
        });
        
        // Select the first option (usually "All" or default)
        const firstOption = allOptions[0];
        if (firstOption) {
          firstOption.classList.add('selected');
        }
        
        // Update button text
        const button = dropdown.querySelector('.filter-button');
        const label = button.querySelector('.filter-label');
        if (label && firstOption) {
          label.textContent = this.getOptionLabel(firstOption);
          if (isMultiSelect && options) {
            this.updateSelectedCount(options);
          }
        }
        
        // Close any open dropdowns
        if (options) {
          options.classList.remove('show');
          options.style.display = 'none';
        }
        
        // Remove active state from button
        button.classList.remove('active');
      });
      
      // Show all products in the current step
      const products = stepElement.querySelectorAll('.product-card');
      products.forEach(product => {
        product.style.display = 'block';
      });
      
      // Update product count
      const productCount = stepElement.querySelector('.product-count');
      if (productCount) {
        productCount.textContent = `${products.length} products`;
      }
      
      console.log(`Reset complete for ${step} - showing all ${products.length} products`);
    }
  
    updateNavigation() {
      const prevBtn = document.getElementById('prev-btn');
      const nextBtn = document.getElementById('next-btn');
      const navContainer = document.querySelector('.co-ords-navigation');
      
      // Show/hide previous button (hide on color step)
      if (this.currentStep > 0) {
        prevBtn.style.display = 'inline-block';
      } else {
        prevBtn.style.display = 'none';
      }
      
      // Show/hide next button (hide on color step and review step)
      if (this.currentStep > 0 && this.currentStep < this.totalSteps - 1) {
        nextBtn.style.display = 'inline-block';
      } else {
        nextBtn.style.display = 'none';
      }
  
      // Hide the entire nav container on color step to remove extra spacing
      if (navContainer) {
        navContainer.style.display = this.currentStep === 0 ? 'none' : 'flex';
      }
    }
  
    openSizeChart(){
      if(this.currentProduct && this.currentProduct.sizeChartUrl){
        this.sizeChartImage.src=this.currentProduct.sizeChartUrl;
        this.sizeChartModal.style.display = 'flex';
        document.body.style.overflow = 'hidden';
      }
    }
  
    closeSizeChart(){
      this.sizeChartModal.style.display = 'none';
      this.sizeChartImage.src = '';
      document.body.style.overflow = '';
    }
  
    initSizeChartModal(){
      if(this.sizeChartModal){
        this.sizeChartModal.addEventListener('click' , (e)=>{
          if(e.target === this.sizeChartModal){
            this.closeSizeChart();
          }
        })
      }
  
      if(this.closeSizeChartBtn){
        this.closeSizeChartBtn.addEventListener('click', ()=>{
          this.closeSizeChart();
        })
      }
  
      if(this.viewSizeChartBtn){
        this.viewSizeChartBtn.addEventListener('click' , ()=>{
          this.openSizeChart();
        })
      }
    }
  
    initFilters() {
      // Initialize filters for tops
      this.initStepFilters('tops');
      // Initialize filters for bottoms
      this.initStepFilters('bottoms');
    }
  
    initStepFilters(step) {
      // Initialize dropdown filters with step-specific names
      this.initDropdownFilter(step, `availability-${step}`);
      this.initDropdownFilter(step, `price-${step}`);
      this.initDropdownFilter(step, `color-${step}`);
      this.initDropdownFilter(step, `sort-${step}`);
    }
  
    initDropdownFilter(step, filterType) {
      console.log(`Initializing ${filterType} filter for ${step}`);
      
      // Find all dropdowns with this filter type
      const dropdowns = document.querySelectorAll(`[data-filter="${filterType}"]`);
      console.log(`Found ${dropdowns.length} dropdowns for ${filterType}`);
      
      dropdowns.forEach((dropdown, index) => {
        const button = dropdown.querySelector('.filter-button');
        const options = dropdown.querySelector('.filter-options');
        const optionElements = dropdown.querySelectorAll('.filter-option');
  
        if (!button || !options || optionElements.length === 0) {
          console.log(`Missing elements for ${filterType} dropdown ${index}`);
          return;
        }
  
        const isColorFilter = filterType.includes('color-');
  
        console.log(`Setting up ${filterType} dropdown ${index}`);
  
        // Remove any existing event listeners by cloning the button
        const newButton = button.cloneNode(true);
        button.parentNode.replaceChild(newButton, button);
  
        // 🔒 Lock shade filter ONLY on bottoms; tops remain interactive
        if (isColorFilter && step === 'bottoms') {
          // Visually indicate non-clickable
          newButton.disabled = true;
          newButton.style.cursor = 'default';
  
          // Prevent any interaction with options panel
          options.style.pointerEvents = 'none';
  
          // Still keep color counts updated for display
          setTimeout(() => {
            this.updateColorCounts(step);
          }, 500);
  
          // Skip attaching any click handlers to keep it read-only
          return;
        }
  
        // Toggle dropdown
        newButton.addEventListener('click', (e) => {
          e.stopPropagation();
          e.preventDefault();
          console.log(`Clicked ${filterType} button ${index}`);
          this.toggleDropdown(newButton, options);
        });
  
        // Handle option selection - re-query after button replacement
        const newOptionElements = dropdown.querySelectorAll('.filter-option');
        newOptionElements.forEach(option => {
          option.addEventListener('click', (e) => {
            e.stopPropagation();
            e.preventDefault();
            console.log(`Selected ${filterType} option:`, option.textContent);
            
            // Check if this is a multi-select dropdown (color filters)
            const isMultiSelect = dropdown.classList.contains('multi-select');
            
            if (isMultiSelect) {
              this.selectMultiFilterOption(newButton, option, options, step, filterType);
            } else {
              this.selectFilterOption(newButton, option, options);
            }
            
            // Trigger filtering/sorting
            if (filterType.includes('sort')) {
              this.sortProducts(step);
            } else {
              this.filterProducts(step);
            }
          });
        });
        
        // Handle reset link for multi-select filters
        if (dropdown.classList.contains('multi-select')) {
          const resetLink = options.querySelector('.filter-reset');
          if (resetLink) {
            resetLink.addEventListener('click', (e) => {
              e.stopPropagation();
              e.preventDefault();
              this.resetMultiSelectFilter(dropdown, step, filterType);
              this.filterProducts(step);
            });
          }
        }
        
        // Initialize product counts for color filters
        if (filterType.includes('color')) {
          setTimeout(() => {
            this.updateColorCounts(step);
          }, 500);
        }
      });
    }
  
    toggleDropdown(button, options) {
      const isOpen = options.classList.contains('show');
      console.log('Toggle dropdown:', { isOpen, button, options });
      
      // Close all other dropdowns first
      document.querySelectorAll('.filter-options.show').forEach(opt => {
        opt.classList.remove('show');
        opt.style.display = 'none';
      });
      document.querySelectorAll('.filter-button.active').forEach(btn => {
        btn.classList.remove('active');
      });
  
      if (!isOpen) {
        options.style.display = 'block';
        options.classList.add('show');
        button.classList.add('active');
        console.log('Dropdown opened - display set to block');
      } else {
        options.style.display = 'none';
        options.classList.remove('show');
        button.classList.remove('active');
        console.log('Dropdown closed - display set to none');
      }
    }
  
    closeDropdown(button, options) {
      options.style.display = 'none';
      options.classList.remove('show');
      button.classList.remove('active');
    }
  
    getOptionLabel(option) {
      if (!option) return '';
      const optionTextElement = option.querySelector('.option-text');
      if (optionTextElement) {
        const clone = optionTextElement.cloneNode(true);
        const countSpan = clone.querySelector('.option-count');
        if (countSpan) {
          countSpan.remove();
        }
        return clone.textContent.trim();
      }
      return option.textContent.trim();
    }
  
    selectFilterOption(button, option, options) {
      // Update button text
      const label = button.querySelector('.filter-label');
      label.textContent = this.getOptionLabel(option);
  
      // Update selected state
      options.querySelectorAll('.filter-option').forEach(opt => {
        opt.classList.remove('selected');
      });
      option.classList.add('selected');
  
      // Close dropdown
      this.closeDropdown(button, options);
    }
  
    selectMultiFilterOption(button, option, options, step, filterType) {
      // Single-select behavior: select one at a time (like the backup)
      if (option.dataset.value === '') {
        // If clicking "All Colors", deselect all others
        options.querySelectorAll('.filter-option').forEach(opt => {
          opt.classList.remove('selected');
        });
        option.classList.add('selected');
      } else {
        // Deselect "All Colors" and all other options
        options.querySelectorAll('.filter-option').forEach(opt => {
          opt.classList.remove('selected');
        });
        
        // Select only the clicked option
        option.classList.add('selected');
      }
      
      // Update selected count
      this.updateSelectedCount(options);
      
      // Update button text - extract text from option-text span or use the option text
      const label = button.querySelector('.filter-label');
      label.textContent = this.getOptionLabel(option);
      
      // If this was a color filter, sync the selection to the other step as well
      if (filterType.includes('color-')) {
        const selectedColor = option.dataset.value || '';
        // track preferred color so add-to-cart & discounts stay in sync
        this.preferredColor = selectedColor || null;
        
        const otherStep = step === 'tops' ? 'bottoms' : 'tops';
        const otherFilterType = `color-${otherStep}`;
        
        // Apply selection to the other step
        this.setFilterSelection(otherStep, otherFilterType, selectedColor);
        this.filterProducts(otherStep);
      }
      
      // Close dropdown after selection (like single-select)
      this.closeDropdown(button, options);
    }
  
    resetMultiSelectFilter(dropdown, step, filterType) {
      const options = dropdown.querySelector('.filter-options');
      const allOption = options.querySelector('.filter-option[data-value=""]');
      
      // Deselect all options
      options.querySelectorAll('.filter-option').forEach(opt => {
        opt.classList.remove('selected');
      });
      
      // Select "All Colors"
      if (allOption) {
        allOption.classList.add('selected');
      }
      
      // Update selected count
      this.updateSelectedCount(options);
      
      // Update button text - extract from option-text if available
      const button = dropdown.querySelector('.filter-button');
      const label = button.querySelector('.filter-label');
      if (label) {
        label.textContent = this.getOptionLabel(allOption) || 'Shades';
      }
    }
  
    updateSelectedCount(options) {
      const countElement = options.querySelector('.selected-count');
      if (!countElement) return;
      
      const selectedCount = options.querySelectorAll('.filter-option.selected:not([data-value=""])').length;
      countElement.textContent = `${selectedCount} selected`;
    }
  
    updateColorCounts(step) {
      const products = document.querySelectorAll(`#${step}-grid .product-card`);
      const colorCounts = {};
      
      products.forEach(product => {
        const productColor = product.dataset.productColor.toLowerCase();
        const productTitle = product.dataset.productTitle;
        const productTags = product.dataset.productTags;
        
        // Map colors based on your existing color mappings
        const colorMappings = {
          'black': ['shadow', 'midnight eclipse', 'new black', 'midnight eclipse (organza silk)','shadow (linen blend)'],
          'brown': ['bark', 'amber (organza silk)', 'bark (pure linen)', 'brown', 'chestnut'],
          'green': ['fern', 'fern (linen blend)', 'green', 'moss', 'moss (pure linen)', 'new green'],
          'off-white': ['stone', 'stone (linen blend)', 'vanilla', 'white', 'off-white', 'off white'],
          'yellow': ['yellow', 'new yellow', 'sundance', 'sundance (linen blend)'],
          'blue': ['blue', 'magpie blue (pure linen)', 'new blue', 'pale iris'],
          'purple': ['purple', 'dusty lavender'],
          'plum': ['plum', 'dusty lavender', 'forest plum (moonga tussar silk)', 'pink'],
          'red': ['red'],
          'beige': ['beige'],
          'blossom': ['blossom'],
          'bronze': ['bronze'],
          'silver': ['silver'],
          'sand': ['sand'],
          'sage': ['sage', 'sage (pure linen)', 'sage (linen blend)']
        };
        
        // Find which color this product matches
        for (const [colorKey, colorValues] of Object.entries(colorMappings)) {
          const colorMatch = colorValues.some(mappedColor => {
            const lowerMappedColor = mappedColor.toLowerCase();
            const titleRegex = new RegExp(`\\b${lowerMappedColor.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`, 'i');
            return productColor.includes(lowerMappedColor) || 
                   titleRegex.test(productTitle) || 
                   titleRegex.test(productTags);
          });
          
          if (colorMatch) {
            colorCounts[colorKey] = (colorCounts[colorKey] || 0) + 1;
            break;
          }
        }
      });
      
      // Update counts in dropdown
      const dropdown = document.querySelector(`[data-filter="color-${step}"]`);
      if (!dropdown) return;
      
      const options = dropdown.querySelectorAll('.filter-option');
      options.forEach(option => {
        const value = option.dataset.value;
        if (value && value !== '') {
          const countElement = option.querySelector('.option-count');
          const count = colorCounts[value.toLowerCase()] || 0;
          if (countElement) {
            countElement.textContent = `(${count})`;
          }
        }
      });
    }
  
    getFilterValue(step, filterType) {
      // Handle both old format (availability, price, color, sort) and new format (availability-tops, etc.)
      let filterName = filterType;
      if (!filterType.includes('-')) {
        filterName = `${filterType}-${step}`;
      }
      
      const dropdown = document.querySelector(`[data-filter="${filterName}"]`);
      if (!dropdown) return '';
      
      // Single select behavior (works for both regular and multi-select styled dropdowns)
      const selectedOption = dropdown.querySelector('.filter-option.selected');
      return selectedOption ? selectedOption.dataset.value : '';
    }
  
    filterProducts(step) {
      const products = document.querySelectorAll(`#${step}-grid .product-card`);
      
      // Get filter values from dropdowns using step-specific names
      const availabilityValue = this.getFilterValue(step, `availability-${step}`);
      const priceValue = this.getFilterValue(step, `price-${step}`);
      const colorValue = this.getFilterValue(step, `color-${step}`);
      
      // Debug logging
      console.log(`Filtering ${step}:`, { availabilityValue, priceValue, colorValue });
      
      let visibleCount = 0;
  
      products.forEach((product) => {
        let show = true;
  
        // Availability filter
        if (availabilityValue) {
          const isAvailable = product.dataset.productAvailable === 'true';
          if (availabilityValue === 'available' && !isAvailable) show = false;
          if (availabilityValue === 'sold-out' && isAvailable) show = false;
        }
  
        // Price filter
        if (priceValue && show) {
          const price = parseInt(product.dataset.productPrice);
          const priceInRupees = price / 100; // Convert from cents to rupees
          
          switch (priceValue) {
            case '0-1000':
              if (priceInRupees >= 1000) show = false;
              break;
            case '1000-2000':
              if (priceInRupees < 1000 || priceInRupees >= 2000) show = false;
              break;
            case '2000-3000':
              if (priceInRupees < 2000 || priceInRupees >= 3000) show = false;
              break;
            case '3000-5000':
              if (priceInRupees < 3000 || priceInRupees >= 5000) show = false;
              break;
            case '5000+':
              if (priceInRupees < 5000) show = false;
              break;
          }
        }
  
        // Color filter
        if (colorValue && show) {
          const productColor = product.dataset.productColor.toLowerCase();
          const productTitle = product.dataset.productTitle;
          const productTags = product.dataset.productTags;
          
          const searchColor = colorValue.toLowerCase();
          
          // Color mapping based on your metaobject structure
          const colorMappings = {
            'black': ['shadow', 'midnight eclipse', 'new black', 'midnight eclipse (organza silk)'],
            'brown': ['bark', 'amber (organza silk)', 'bark (pure linen)', 'brown', 'chestnut'],
            'green': ['fern', 'fern (linen blend)', 'green', 'moss', 'moss (pure linen)', 'new green'],
            'off-white': ['stone', 'stone (linen blend)', 'vanilla', 'white', 'off-white', 'off white'],
            'yellow': ['yellow', 'new yellow', 'sundance', 'sundance (linen blend)'],
            'blue': ['blue', 'magpie blue (pure linen)', 'new blue', 'pale iris'],
            'purple': ['purple', 'dusty lavender'],
            'plum': ['plum', 'dusty lavender', 'forest plum (moonga tussar silk)', 'pink'],
            'red': ['red'],
            'beige': ['beige'],
            'blossom': ['blossom'],
            'bronze': ['bronze'],
            'silver': ['silver'],
            'sand': ['sand'],
            'sage': ['sage', 'sage (pure linen)', 'sage (linen blend)']
          };
          
          // Check if the product color matches the selected color or any of its mapped values
          const mappedColors = colorMappings[searchColor] || [searchColor];
          const colorMatch = mappedColors.some(mappedColor => {
            const lowerMappedColor = mappedColor.toLowerCase();
            
            // More precise matching using word boundaries
            const productColorMatch = productColor.includes(lowerMappedColor);
            
            // Use word boundary regex for title and tags to avoid partial matches
            const titleRegex = new RegExp(`\\b${lowerMappedColor.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`, 'i');
            const productTitleMatch = titleRegex.test(productTitle);
            const productTagsMatch = titleRegex.test(productTags);
            
            
            return productColorMatch || productTitleMatch || productTagsMatch;
          });
          
          if (!colorMatch) show = false;
        }
  
        // Show/hide product
        product.style.display = show ? 'block' : 'none';
        if (show) visibleCount++;
      });
  
      // Update product count
      this.updateProductCount(step, visibleCount);
    }
  
    sortProducts(step) {
      console.log(`Sorting products for ${step}`);
      const productGrid = document.getElementById(`${step}-grid`);
      const products = Array.from(productGrid.querySelectorAll('.product-card'));
      const sortValue = this.getFilterValue(step, `sort-${step}`);
      
      console.log(`Sort value: ${sortValue}, Products count: ${products.length}`);
  
      products.sort((a, b) => {
        switch (sortValue) {
          case 'title-ascending':
            return a.dataset.productTitle.localeCompare(b.dataset.productTitle);
          case 'title-descending':
            return b.dataset.productTitle.localeCompare(a.dataset.productTitle);
          case 'price-ascending':
            return parseInt(a.dataset.productPrice) - parseInt(b.dataset.productPrice);
          case 'price-descending':
            return parseInt(b.dataset.productPrice) - parseInt(a.dataset.productPrice);
          default:
            return 0;
        }
      });
  
      // Re-append sorted products
      products.forEach(product => {
        productGrid.appendChild(product);
      });
      
      console.log(`Sorting completed for ${step}`);
    }
  
    updateProductCount(step, count) {
      const countElement = document.getElementById(`product-count-${step}`);
      if (countElement) {
        countElement.textContent = `${count} products`;
      }
    }
  
    async addToCartAndCheckout() {
      if (!this.selectedTop || !this.selectedBottom) {
        this.showError('Please select both a top and bottom before proceeding.');
        return;
      }
    
      try {
        // Show loading state
        const addToCartBtn = document.getElementById('add-to-cart-btn');
        const originalText = addToCartBtn.textContent;
        addToCartBtn.textContent = 'Adding to Cart...';
        addToCartBtn.disabled = true;
    
        // Use the form submission method
        this.redirectToCartWithProductsAndCheckout();
    
      } catch (error) {
        console.error('Error adding to cart:', error);
        this.showError('An error occurred. Redirecting to cart page...');
        addToCartBtn.textContent = originalText;
        addToCartBtn.disabled = false;
      }
    }
  
    async redirectToCartWithProductsAndCheckout() {
      const topId = this.selectedTop.variantId || this.selectedTop.id;
      const bottomId = this.selectedBottom.variantId || this.selectedBottom.id;
      
      // Directly add both products to cart without removing existing items
      this.addCoordsToCart(topId, bottomId);
    }
  
    addCoordsToCart(topId, bottomId) {
    // Create a form to add co-ords to cart
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = '/cart/add';
  
    // Add top product
    const topInput = document.createElement('input');
    topInput.type = 'hidden';
    topInput.name = 'items[0][id]';
    topInput.value = topId;
    form.appendChild(topInput);
  
    const topQtyInput = document.createElement('input');
    topQtyInput.type = 'hidden';
    topQtyInput.name = 'items[0][quantity]';
    topQtyInput.value = '1';
    form.appendChild(topQtyInput);
  
    // ✅ ADD TOP PROPERTIES (PASTE HERE)
    const topPropSource = document.createElement('input');
    topPropSource.type = 'hidden';
    topPropSource.name = 'items[0][properties][_coord_source]';
    topPropSource.value = 'selector';
    form.appendChild(topPropSource);
  
    const topPropRole = document.createElement('input');
    topPropRole.type = 'hidden';
    topPropRole.name = 'items[0][properties][_coord_role]';
    topPropRole.value = 'top';
    form.appendChild(topPropRole);
  
    // Add selected color if available
    if (this.preferredColor) {
      const topPropColor = document.createElement('input');
      topPropColor.type = 'hidden';
      topPropColor.name = 'items[0][properties][_coord_color]';
      topPropColor.value = this.preferredColor;
      form.appendChild(topPropColor);
    }
  
    // Add bottom product
    const bottomInput = document.createElement('input');
    bottomInput.type = 'hidden';
    bottomInput.name = 'items[1][id]';
    bottomInput.value = bottomId;
    form.appendChild(bottomInput);
  
    const bottomQtyInput = document.createElement('input');
    bottomQtyInput.type = 'hidden';
    bottomQtyInput.name = 'items[1][quantity]';
    bottomQtyInput.value = '1';
    form.appendChild(bottomQtyInput);
  
    // ✅ ADD BOTTOM PROPERTIES (PASTE HERE)
    const bottomPropSource = document.createElement('input');
    bottomPropSource.type = 'hidden';
    bottomPropSource.name = 'items[1][properties][_coord_source]';
    bottomPropSource.value = 'selector';
    form.appendChild(bottomPropSource);
  
    const bottomPropRole = document.createElement('input');
    bottomPropRole.type = 'hidden';
    bottomPropRole.name = 'items[1][properties][_coord_role]';
    bottomPropRole.value = 'bottom';
    form.appendChild(bottomPropRole);
  
    // Add selected color if available
    if (this.preferredColor) {
      const bottomPropColor = document.createElement('input');
      bottomPropColor.type = 'hidden';
      bottomPropColor.name = 'items[1][properties][_coord_color]';
      bottomPropColor.value = this.preferredColor;
      form.appendChild(bottomPropColor);
    }
  
    // Add return URL to take customer to cart after adding
    const returnInput = document.createElement('input');
    returnInput.type = 'hidden';
    returnInput.name = 'return_to';
    returnInput.value = this.buildReturnToUrl();
    form.appendChild(returnInput);
  
    // Submit form
    document.body.appendChild(form);
    form.submit();
  }
  
  
    getDiscountPercent() {
      if (!this.sectionRoot) {
        return 5;
      }
      const raw = parseFloat(this.sectionRoot.dataset.discountPercent);
      return Number.isFinite(raw) ? raw : 5;
    }
  
    getDiscountCode() {
      if (!this.sectionRoot) {
        return '';
      }
      return (this.sectionRoot.dataset.discountCode || '').trim();
    }
  
    getPreviewThemeId() {
      const params = new URLSearchParams(window.location.search);
      return params.get('preview_theme_id') || '';
    }
  
    getColorSpecificDiscountCode() {
      // Map color names to discount codes
      const colorToDiscountMap = {
        'Black': 'CHAOCOORDS - SHADOW',
        'Brown': 'CHAOCOORDS - BARK',
        'Blue': 'CHAOCOORDS - MAGPIE BLUE',
        'Off-White': 'CHAOCOORDS - STONE',
        'Sand': 'CHAOCOORDS - SAND',
        'Sage': 'CHAOCOORDS - SAGE'
      };
  
      // Use preferred color if available, otherwise fall back to static discount code
      if (this.preferredColor && colorToDiscountMap[this.preferredColor]) {
        return colorToDiscountMap[this.preferredColor];
      }
  
      // Fallback to static discount code from settings if no color match
      return this.discountCode || '';
    }
  
    buildReturnToUrl() {
      const previewId = this.getPreviewThemeId();
      const cartPath = previewId ? `/cart?preview_theme_id=${previewId}` : '/cart';
  
      // Get color-specific discount code
      const discountCode = this.getColorSpecificDiscountCode();
  
      if (discountCode) {
        const search = new URLSearchParams();
        search.set('redirect', cartPath);
        if (previewId) {
          search.set('preview_theme_id', previewId);
        }
        return `/discount/${encodeURIComponent(discountCode)}?${search.toString()}`;
      }
  
      return cartPath;
    }
    
    redirectToCartWithProducts() {
      const topId = this.selectedTop.variantId || this.selectedTop.id;
      const bottomId = this.selectedBottom.variantId || this.selectedBottom.id;
      
      // Create a form and submit it to add products to cart
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = '/cart/add';
      
      // Add top product
      const topInput = document.createElement('input');
      topInput.type = 'hidden';
      topInput.name = 'items[0][id]';
      topInput.value = topId;
      form.appendChild(topInput);
      
      const topQtyInput = document.createElement('input');
      topQtyInput.type = 'hidden';
      topQtyInput.name = 'items[0][quantity]';
      topQtyInput.value = '1';
      form.appendChild(topQtyInput);
      
      // Add bottom product
      const bottomInput = document.createElement('input');
      bottomInput.type = 'hidden';
      bottomInput.name = 'items[1][id]';
      bottomInput.value = bottomId;
      form.appendChild(bottomInput);
      
      const bottomQtyInput = document.createElement('input');
      bottomQtyInput.type = 'hidden';
      bottomQtyInput.name = 'items[1][quantity]';
      bottomQtyInput.value = '1';
      form.appendChild(bottomQtyInput);
      
      const returnToInput = document.createElement('input');
      returnToInput.type = 'hidden';
      returnToInput.name = 'return_to';
      returnToInput.value = '/cart';
      form.appendChild(returnToInput);
  
      // Submit form
      document.body.appendChild(form);
      form.submit();
    }
  
    async addProductsToCart(items) {
      try {
        // Use the standard form submission method instead of AJAX
        const formData = new FormData();
        
        items.forEach((item, index) => {
          formData.append(`items[${index}][id]`, item.id);
          formData.append(`items[${index}][quantity]`, item.quantity);
        });
  
        const response = await fetch('/cart/add', {
          method: 'POST',
          body: formData
        });
  
        if (response.ok) {
          return { success: true };
        } else {
          return { success: false, error: 'Failed to add to cart' };
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
        return { success: false, error: error.message };
      }
    }
  
    showError(message) {
      // Create error notification
      const errorDiv = document.createElement('div');
      errorDiv.className = 'co-ords-error';
      errorDiv.textContent = message;
      errorDiv.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: #ff4444;
        color: white;
        padding: 15px 20px;
        border-radius: 5px;
        z-index: 1000;
        max-width: 300px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      `;
  
      document.body.appendChild(errorDiv);
  
      // Remove after 5 seconds
      setTimeout(() => {
        if (errorDiv.parentNode) {
          errorDiv.parentNode.removeChild(errorDiv);
        }
      }, 5000);
    }
  
    initColorGate(){
      this.skipColorStepBtn = document.getElementById('skip-color-step-btn');
      this.colorStepOptions = document.getElementById('color-step-options');
  
      if(this.skipColorStepBtn){
        this.skipColorStepBtn.addEventListener('click', ()=>{
          this.nextStep(); // Skip to next step
        })
      }
  
      if(this.colorStepOptions){
        this.colorStepOptions.addEventListener('click', (e)=>{
          // const chip = e.target.closest('.color-chip');
          // if(!chip) return;
          const wrapper = e.target.closest('.color-chip-wrapper');
  if(!wrapper) return;
          
  const chip = wrapper.querySelector('.color-chip');
          // Remove previous selection
          this.colorStepOptions.querySelectorAll('.color-chip').forEach(c => c.classList.remove('selected'));
          
          // Add selection to clicked chip
          chip.classList.add('selected');
          
          const color = chip.dataset.color;
          this.preferredColor = color;
          this.applyPreferredColorToFilters(color);
          
          // Move to next step after a short delay
          setTimeout(() => {
            this.nextStep();
          }, 500);
        })
      }
    }
  
  
    applyPreferredColorToFilters(color) {
      // Wait a bit for filters to be initialized, then apply
      console.log(`Starting to apply color filter: ${color}`);
  
      setTimeout(() => {
        const topsDropdown = document.querySelector('[data-filter="color-tops"]');
        const bottomsDropdown = document.querySelector('[data-filter="color-bottoms"]');
  
  
        console.log('Found dropdowns:', { topsDropdown, bottomsDropdown });
        
        if(!topsDropdown || !bottomsDropdown) {
          // If filters aren't ready yet, try again
          this.applyPreferredColorToFilters(color);
          return;
        }
        
        console.log('Applying filter to tops...');
  
  
        // Apply color filter to tops
        this.setFilterSelection('tops', 'color-tops', color);
        this.filterProducts('tops');
        
        // Apply color filter to bottoms  
  
        console.log('Applying filter to bottoms...');
        this.setFilterSelection('bottoms', 'color-bottoms', color);
        this.filterProducts('bottoms');
        
        console.log(`Applied color filter: ${color}`);
      }, 600); // Wait a bit longer than filter init
    }
    
    setFilterSelection(step, filterType, value) {
      const dropdown = document.querySelector(`[data-filter="${filterType}"]`);
      if(!dropdown) return;
      
      const options = dropdown.querySelector('.filter-options');
      const button = dropdown.querySelector('.filter-button');
      const label = button ? button.querySelector('.filter-label') : null;
      
      // Find the matching option
      let selected = null;
      options.querySelectorAll('.filter-option').forEach(opt => {
        const isMatch = (opt.dataset.value || '').toLowerCase() === String(value).toLowerCase();
        if(isMatch) selected = opt;
      });
      
      if(!selected) return;
      
      // Update the selection
      options.querySelectorAll('.filter-option').forEach(opt => opt.classList.remove('selected'));
      selected.classList.add('selected');
      
      if(label) label.textContent = this.getOptionLabel(selected) || selected.textContent;
    }
  }
  
    
  
  
  // Initialize when DOM is loaded
  document.addEventListener('DOMContentLoaded', () => {
    new CoOrdsSelector();
  });
  
  // Initialize when section is loaded (for Shopify sections)
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.dataset.sectionType === 'co-ords-selector') {
      new CoOrdsSelector();
    }
  
  
  });